import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSnapshot,
  fetchRecentOutreaches,
  fetchPeerPerformance,
} from './actions';

const initialState = {
  timeRange: {
    to: null,
    from: null,
    label: 'Last 7 days',
    id: '7d',
    defaultInterval: 'day',
    intervalOptions: ['day', 'week', 'month'],
  },
  snapshot: {
    isLoading: true,
    data: [],
    filter: { changed: false, recruiters: [] },
  },
  recentOutreaches: {
    isLoading: true,
    data: [],
  },
  peerPerformance: {
    isLoading: true,
    data: [],
    page: 1,
    filter: { changed: false, recruiters: [] },
  },
};

const { reducer, actions } = createSlice({
  name: 'dashboardSnapshot',
  initialState,

  reducers: {
    applyTimeRange: (state, { payload }) => {
      const { to, from, label, id, defaultInterval, intervalOptions } = payload;
      state.timeRange.to = to;
      state.timeRange.from = from;
      state.timeRange.label = label;
      state.timeRange.id = id;
      state.timeRange.defaultInterval = defaultInterval;
      state.timeRange.intervalOptions = intervalOptions;
    },
    applyPeerPerformanceFilter: (state, { payload }) => {
      const { type, value } = payload;
      state.peerPerformance.filter[type] = value;
      state.peerPerformance.filter.changed = true;
    },
    clearPeerPerformanceFilter: (state, { payload }) => {
      const { type, isMulti = false } = payload;
      state.peerPerformance.filter[type] = isMulti ? [] : null;
      state.peerPerformance.filter.changed = false;
    },
    applySnapShotFilter: (state, { payload }) => {
      const { type, value } = payload;
      state.snapshot.filter[type] = value;
      state.snapshot.filter.changed = true;
    },
    clearSnapShotFilter: (state, { payload }) => {
      const { type, isMulti = false } = payload;
      state.snapshot.filter[type] = isMulti ? [] : null;
      state.snapshot.filter.changed = false;
    },
    applyPeerPerformancePage: (state, { payload }) => {
      const { type, value } = payload;
      state.peerPerformance[type] = value;
    },
    clearPeerPerformancePage: (state, { payload }) => {
      const { type } = payload;
      state.peerPerformance[type] = 1;
    },
  },

  extraReducers: {
    [fetchSnapshot.pending]: (state) => {
      state.snapshot.isLoading = true;
    },

    [fetchSnapshot.fulfilled]: (state, { payload }) => {
      state.snapshot.data = payload?.data || {};
      state.snapshot.isLoading = false;
    },

    [fetchRecentOutreaches.pending]: (state) => {
      state.recentOutreaches.isLoading = true;
    },

    [fetchRecentOutreaches.fulfilled]: (state, { payload }) => {
      state.recentOutreaches.data = payload || {};
      state.recentOutreaches.isLoading = false;
    },

    [fetchPeerPerformance.pending]: (state) => {
      state.peerPerformance.isLoading = true;
    },

    [fetchPeerPerformance.fulfilled]: (state, { payload }) => {
      state.peerPerformance.data = payload || {};
      state.peerPerformance.isLoading = false;
    },
  },
});

export const {
  applyTimeRange,
  applySnapShotFilter,
  clearSnapShotFilter,
  applyPeerPerformanceFilter,
  clearPeerPerformanceFilter,
  applyPeerPerformancePage,
  clearPeerPerformancePage,
} = actions;

export default reducer;
